module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/main/energy/energy-add/energy-add.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/main/energy/energy-add/energy-add.component.css
// module chunks = main